module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABHNCSVQICAgIfAhkiAAAANRJREFUKFOdklENwkAQRN84QAISkAAOwEElgIM6oDhAQh2AA0ABSKiDIdMcJBRIKPtzyd293ZndFYOwPQG2QAUcgY2k8/CfPoDrAs2BGphKWv4C7oGbpNp24IOktwIvF0XmFVhE3k9g+RRvF0nxh+1Z8XkqUm/ALkllu40H2x2wlxSPzygJIzmRxiXpLKDjIWeRmE5+Ddt5r/8BI7caBdqeAtcoHAvGXyVpPhZsgC4zHgtm9WpJ7RDst+ZLSzOKVT8KqQu4ltTYzl4+5vWJTbVGUp/4DnlFm6bA/a7tAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/pariseHelp.png
// module id = Dt+E
// module chunks = 3